import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Container, Row, Col, Tab, Nav } from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/course.js';
import { getAssetUrl } from '../../helper/assets';
import { countryUniversitiesMap } from '../../data/pages/countries/universities';

// Import all country-wise JSON databases
import malaysiaData from '../../data/pages/countries/malaysia-course-details.json';
import maltaData from '../../data/pages/countries/malta-course-details.json';
import greeceData from '../../data/pages/countries/greece-course-details.json';
import usaData from '../../data/pages/countries/usa-course-details.json';
import cyprusData from '../../data/pages/countries/cyprus-course-details.json';
import vietnamData from '../../data/pages/countries/vietnam-course-details.json';
import indiaData from '../../data/pages/countries/india-course-details.json';
import australiaData from '../../data/pages/countries/australia-course-details.json';
import canadaData from '../../data/pages/countries/canada-course-details.json';
import germanyData from '../../data/pages/countries/germany-course-details.json';
import ukData from '../../data/pages/countries/uk-course-details.json';
import southkoreaData from '../../data/pages/countries/southkorea-course-details.json';
import japanData from '../../data/pages/countries/japan-course-details.json';
import europeData from '../../data/pages/countries/europe-course-details.json';

const countryDataMap = {
    malaysia: malaysiaData,
    malta: maltaData,
    greece: greeceData,
    usa: usaData,
    cyprus: cyprusData,
    cipras: cyprusData,
    ciprus: cyprusData,
    vietnam: vietnamData,
    india: indiaData,
    australia: australiaData,
    canada: canadaData,
    germany: germanyData,
    uk: ukData,
    southkorea: southkoreaData,
    japan: japanData,
    europe: europeData
};

const countryNameMap = {
    malaysia: "Malaysia",
    malta: "Malta",
    greece: "Greece",
    usa: "USA",
    cyprus: "Cyprus",
    cipras: "Cyprus",
    ciprus: "Cyprus",
    vietnam: "Vietnam",
    india: "India",
    australia: "Australia",
    canada: "Canada",
    germany: "Germany",
    uk: "UK",
    southkorea: "South Korea",
    japan: "Japan",
    europe: "Europe"
};


const countryCourseTypeMap = {
    malaysia: "Foundation",
    malta: "Bachelors, Masters, Research / Doctorate",
    greece: "Bachelors, Masters, Research / Doctorate",
    usa: "Bachelors, Masters, Research / Doctorate",
    cyprus: "Bachelors, Masters, Research / Doctorate",
    cipras: "Bachelors, Masters, Research / Doctorate",
    ciprus: "Bachelors, Masters, Research / Doctorate",
    vietnam: "Foundation, Bachelors, Masters",
    india: "Foundation, Bachelors, Masters, Research / Doctorate",
    australia: "Bachelors, Masters, Research / Doctorate",
    canada: "Bachelors, Masters, Research / Doctorate",
    germany: "Bachelors, Masters, Research / Doctorate",
    uk: "Bachelors, Masters, Research / Doctorate",
    southkorea: "Bachelors, Masters, Research / Doctorate",
    japan: "Bachelors, Masters, Research / Doctorate",
    europe: "Bachelors, Masters, Research / Doctorate"
};

const countryDurationMap = {
    malaysia: "01 year",
    malta: "04 years",
    greece: "04 years",
    usa: "04 years (study gap allowed max 3 years)",
    cyprus: "04 years",
    cipras: "04 years",
    ciprus: "04 years",
    vietnam: "02 years (study gap allowed max 2 years)",
    india: "04 years",
    australia: "04 years",
    canada: "04 years",
    germany: "04 years",
    uk: "04 years",
    southkorea: "04 years",
    japan: "04 years",
    europe: "04 years"
};

const countryLanguageMap = {
    malaysia: "English",
    malta: "English",
    greece: "English",
    usa: "English",
    cyprus: "English",
    cipras: "English",
    ciprus: "English",
    vietnam: "English",
    india: "English",
    australia: "English",
    canada: "English",
    germany: "English",
    uk: "English",
    southkorea: "English",
    japan: "English",
    europe: "English"
};

const countryLeadingToMap = {
    malaysia: "Europe, USA, Canada, Australia",
    malta: "N/A",
    greece: "N/A",
    usa: "N/A",
    cyprus: "N/A",
    cipras: "N/A",
    ciprus: "N/A",
    vietnam: "Japan, South Korea",
    india: "N/A",
    australia: "N/A",
    canada: "N/A",
    germany: "N/A",
    uk: "N/A",
    southkorea: "N/A",
    japan: "N/A",
    europe: "N/A"
};

const countryIeltsRequiredMap = {
    malaysia: "Not Required",
    malta: "Not Required",
    greece: "Required (4-5) / Not Required",
    usa: "Required / Not Required",
    cyprus: "Required (4-5) / Not Required",
    cipras: "Required (4-5) / Not Required",
    ciprus: "Required (4-5) / Not Required",
    vietnam: "Not Required",
    india: "Not Required",
    australia: "Required (6.5+)",
    canada: "Required (6.5+)",
    germany: "Required (6.5+)",
    uk: "Required (6.5+)",
    southkorea: "Required (6.5+)",
    japan: "Required (6.5+)",
    europe: "Required (4-5) / Not Required"
};

function CourseDetails() {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const country = query.get('country') || 'malaysia';
    
    const pageData = countryDataMap[country.toLowerCase()] || malaysiaData;
    const countryName = countryNameMap[country.toLowerCase()] || country;

    const countryKey = country.toLowerCase();
    const resolvedCountry = countryKey === 'cipras' || countryKey === 'ciprus' ? 'cyprus' : countryKey;
    const countryImgName = resolvedCountry === 'southkorea' ? 'south_korea' : resolvedCountry;
    const bannerPath = `globalAbroad/countries/detail_banners/${countryImgName}.png`;

    const universities = countryUniversitiesMap[resolvedCountry] || [];

    const [activeUniIndex, setActiveUniIndex] = useState(null);

    useEffect(() => {
        setActiveUniIndex(null);
    }, [country]);

    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        setIsLoaded(false);
    }, [bannerPath]);

    const renderSidebarFeatures = () => (
        <div className="single-details-sidbar">
            <Row>
                <Col md="12">
                    <div className="course-details-feature">
                        <h5 className="title">{pageData.sidebar.title}</h5>
                        <ul className="list-unstyled feature-list">
                            <li>
                                <span className="feat-title">
                                    <i className="las la-graduation-cap"></i> Course Type:
                                </span>
                                <span className="feat-value">{
                                    pageData.sidebar.courseType || 
                                    countryCourseTypeMap[country.toLowerCase()] || 
                                    ""
                                }</span>
                            </li>
                            <li>
                                <span className="feat-title">
                                    <i className="las la-clock"></i> Duration:
                                </span>
                                <span className="feat-value">{
                                    countryDurationMap[country.toLowerCase()] || 
                                    pageData.sidebar.features?.find(feat => feat.label === "Duration")?.value || 
                                    ""
                                }</span>
                            </li>
                            <li>
                                <span className="feat-title">
                                    <i className="las la-globe"></i> Language:
                                </span>
                                <span className="feat-value">{
                                    countryLanguageMap[country.toLowerCase()] || 
                                    pageData.sidebar.features?.find(feat => feat.label === "Language")?.value || 
                                    "English"
                                }</span>
                            </li>
                            <li>
                                <span className="feat-title">
                                    <i className="las la-map-marker"></i> Leading To:
                                </span>
                                <span className="feat-value">{
                                    pageData.sidebar.leadingTo || 
                                    countryLeadingToMap[country.toLowerCase()] || 
                                    ""
                                }</span>
                            </li>
                            <li>
                                <span className="feat-title">
                                    <i className="las la-file-contract"></i> IELTS:
                                </span>
                                <span className="feat-value">{
                                    pageData.sidebar.ielts || 
                                    countryIeltsRequiredMap[country.toLowerCase()] || 
                                    "Required"
                                }</span>
                            </li>
                        </ul>
                    </div>
                </Col>
            </Row>
        </div>
    );

    return (
        <div className="main-wrapper course-details-page" >

            {/* Header 2 */}
            < HeaderTwo />

            {/* Breadcroumb */}
            < BreadcrumbBox 
                title={countryName} 
                bgImage="globalAbroad/course_details_header.png" 
                parentItem="Countries" 
                parentLink={process.env.PUBLIC_URL + "/"}
            />

            <Styles>
                {/* Course Details */}
                <section className="course-details-area">
                    <Container>
                        <Row>
                            <Col lg="9" md="8" sm="12">
                                <div className="course-details-top">
                                    <div className="heading">
                                        <h4>{pageData.heading}</h4>
                                    </div>
                                    <div className="course-details-banner" style={{ position: 'relative', overflow: 'hidden', minHeight: '300px', background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        {!isLoaded && (
                                            <div className="banner-loader" style={{ position: 'absolute', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', zIndex: 2 }}>
                                                <div style={{
                                                    width: '40px',
                                                    height: '40px',
                                                    border: '4px solid rgba(0,0,0,0.1)',
                                                    borderTop: '4px solid #00a859',
                                                    borderRadius: '50%',
                                                    animation: 'spin 1s linear infinite'
                                                }} />
                                                <style>{`
                                                    @keyframes spin {
                                                        0% { transform: rotate(0deg); }
                                                        100% { transform: rotate(360deg); }
                                                    }
                                                `}</style>
                                            </div>
                                        )}
                                        <img 
                                            src={getAssetUrl(bannerPath)} 
                                            alt="" 
                                            className="img-fluid" 
                                            onLoad={() => setIsLoaded(true)}
                                            style={{
                                                transition: 'opacity 0.35s ease-in-out, filter 0.35s ease-in-out',
                                                opacity: isLoaded ? 1 : 0.3,
                                                filter: isLoaded ? 'none' : 'blur(8px)',
                                                width: '100%'
                                            }}
                                        />
                                    </div>
                                    <div className="d-block d-md-none" style={{ marginBottom: '30px' }}>
                                        {renderSidebarFeatures()}
                                    </div>
                                    <div className="course-tab-list">
                                        <Tab.Container defaultActiveKey="overview">
                                            <Nav className="flex-column">
                                                <Nav.Item>
                                                    <Nav.Link eventKey="overview">Overview</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link eventKey="curriculum">Universities</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link eventKey="review">Reviews</Nav.Link>
                                                </Nav.Item>
                                            </Nav>
                                            <Tab.Content>
                                                <Tab.Pane eventKey="overview" className="overview-tab">
                                                    <div className="course-desc">
                                                        <h5>{pageData.overviewTab.title}</h5>
                                                        <p dangerouslySetInnerHTML={{ __html: pageData.overviewTab.description }}></p>
                                                    </div>
                                                    <div className="course-feature">
                                                        <h5>{pageData.overviewTab.features.title}</h5>
                                                        <p>{pageData.overviewTab.features.description}</p>
                                                        <ul className="list-unstyled">
                                                            {pageData.overviewTab.features.list.map((item, i) => (
                                                                <li key={i}><i className="las la-arrow-right"></i> {item}</li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                    <div className="course-learn">
                                                        <h5>{pageData.overviewTab.learningOutcome.title}</h5>
                                                        <p>{pageData.overviewTab.learningOutcome.description}</p>
                                                        <ul className="list-unstyled">
                                                            {pageData.overviewTab.learningOutcome.list.map((item, i) => (
                                                                <li key={i}><i className="fa fa-check"></i> {item}</li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                    {pageData.overviewTab.recommendedUniversities && (
                                                        <div className="course-recommended" style={{ marginTop: '30px', marginBottom: '30px' }}>
                                                            <h5>{pageData.overviewTab.recommendedUniversities.title}</h5>
                                                            <div className="table-responsive" style={{ marginTop: '15px' }}>
                                                                <table className="table table-bordered table-striped" style={{ background: '#fff' }}>
                                                                    <thead style={{ background: '#00a859', color: '#fff' }}>
                                                                        <tr>
                                                                            <th style={{ width: '40%', padding: '12px 15px' }}>Study Goal</th>
                                                                            <th style={{ padding: '12px 15px' }}>Recommended Universities</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {pageData.overviewTab.recommendedUniversities.list.map((row, idx) => (
                                                                            <tr key={idx}>
                                                                                <td style={{ fontWeight: '600', color: '#333', padding: '10px 15px' }}>{row.goal}</td>
                                                                                <td style={{ color: '#555', padding: '10px 15px' }}>{row.universities}</td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            {pageData.overviewTab.recommendedUniversities.summary && (
                                                                <p style={{ marginTop: '15px' }}>
                                                                    {pageData.overviewTab.recommendedUniversities.summary}
                                                                </p>
                                                            )}
                                                        </div>
                                                    )}
                                                    <div className="course-share">
                                                        <h5>{pageData.overviewTab.shareTitle}</h5>
                                                        <ul className="social list-unstyled list-inline">
                                                            <li className="list-inline-item"><a href="https://www.facebook.com/globalabroadbd" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a></li>
                                                            <li className="list-inline-item"><a href="https://www.instagram.com/globalabroadbd/?hl=en" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a></li>
                                                        </ul>
                                                    </div>
                                                </Tab.Pane>
                                                <Tab.Pane eventKey="curriculum" className="curriculum-tab">
                                                    <div className="course-curriculum">
                                                        <h5>Universities we Offer</h5>
                                                        <p>We partner with several leading colleges and universities in {countryName} to offer a wide range of academic programs for international students. Our partner institutions are recognized globally for their academic excellence, modern infrastructure, and student support services. We assist students throughout the application and admission process to ensure a smooth transition to studying in {countryName}.</p>
                                                    </div>
                                                    <div className="course-element">
                                                        {universities.map((uni, i) => {
                                                            const isActive = activeUniIndex === i;
                                                            return (
                                                                <div className="course-item" key={i}>
                                                                     <button 
                                                                         className={`course-button${isActive ? ' active' : ''}`}
                                                                         onClick={() => setActiveUniIndex(isActive ? null : i)}
                                                                         style={{
                                                                             display: 'flex',
                                                                             justifyContent: 'space-between',
                                                                             alignItems: 'center',
                                                                             width: '100%',
                                                                             padding: '12px 18px',
                                                                             background: isActive ? '#f4fbf7' : '#f9fafb',
                                                                             border: isActive ? '1px solid #00a859' : '1px solid #e5e7eb',
                                                                             borderRadius: '6px',
                                                                             cursor: 'pointer',
                                                                             marginBottom: '10px',
                                                                             transition: 'all 0.2s ease-in-out'
                                                                         }}
                                                                     >
                                                                         <span style={{ fontWeight: '600', fontSize: '16px', color: isActive ? '#00a859' : '#1f2937' }}>
                                                                             {uni.name}
                                                                         </span>
                                                                         <i 
                                                                             className="las la-angle-down" 
                                                                             style={{
                                                                                 fontSize: '18px',
                                                                                 color: isActive ? '#00a859' : '#6b7280',
                                                                                 transform: isActive ? 'rotate(180deg)' : 'rotate(0deg)',
                                                                                 transition: 'transform 0.25s ease-in-out',
                                                                                 marginLeft: '15px',
                                                                                 flexShrink: 0
                                                                             }}
                                                                         ></i>
                                                                     </button>
                                                                    <div 
                                                                        className={`course-content${isActive ? ' show' : ''}`}
                                                                        style={{ 
                                                                            maxHeight: isActive ? '800px' : '0', 
                                                                            overflow: 'hidden', 
                                                                            transition: 'max-height 0.25s ease-in-out'
                                                                        }}
                                                                    >
                                                                        <ul className="list-unstyled" style={{ padding: '5px 0' }}>
                                                                            {uni.highlights.map((hl, hlIdx) => (
                                                                                <li key={hlIdx} style={{ 
                                                                                    display: 'flex', 
                                                                                    justifyContent: 'space-between', 
                                                                                    alignItems: 'flex-start',
                                                                                    gap: '20px',
                                                                                    padding: '10px 15px', 
                                                                                    borderBottom: hlIdx === uni.highlights.length - 1 ? 'none' : '1px solid #f1f1f1',
                                                                                    marginLeft: '0px'
                                                                                }}>
                                                                                    <span style={{ fontWeight: '600', color: '#444', flexShrink: 0, whiteSpace: 'nowrap' }}>{hl.label}:</span>
                                                                                    <span style={{ color: '#666', textAlign: 'right', flexGrow: 1 }}>{hl.value}</span>
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </Tab.Pane>
                                                <Tab.Pane eventKey="review" className="review-tab">
                                                    <Row>
                                                        <Col md="12">
                                                            <div className="review-comments">
                                                                <h5>Course Reviews</h5>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Tab.Pane>
                                            </Tab.Content>
                                        </Tab.Container>
                                    </div>
                                </div>
                            </Col>
                            <Col lg="3" md="4" sm="12" className="d-none d-md-block">
                                {renderSidebarFeatures()}
                            </Col>
                        </Row>
                    </Container>
                </section>
            </Styles>

            {/* Footer 2 */}
            <FooterTwo />

        </div >
    )
}

export default CourseDetails;
